import { BCMSRecord, DisabledPrompt, Link, useGlobalController, useModel } from "bcms-react";
import { CenterContentContainer, ContentHeaderView, FormContainer, FormRowView, PageContainer, PageContentView } from 'components/shared';
import { FormButtonRow } from 'components/shared/containers/FormContainer';
import { UIButton, UITextInput } from 'components/ui';
import { User } from "model";
import React from 'react';
import "./mobile.css";
import "./styles.css";

/**
 * @function EmailPage
 * @return {React.Component}
 * @exported true
 * @description The main component for EmailPage
 */
export default function EmailPage(props) {
  const controller = useGlobalController();
  BCMSRecord.globalControllerFor([ User ], controller);
  const user = User.init(controller.state.user);

  return (
    <PageContainer className="email-page" >
      <PageContentView>
        <CenterContentContainer>
          <ContentHeaderView text="Email Address" />
          <FormContainer className="small-form-width ">
            <FormRowView text={`Current Email: ${user.email.value}`}/>
            <FormRowView text="New Email Address">
              <UITextInput />
            </FormRowView>
            <FormRowView text="Confirm Email Address">
              <UITextInput />
            </FormRowView>
            <FormButtonRow>
            <Link to="/profile" className="flex-width">
                <UIButton className="secondary-button" text="Cancel" />
              </Link>
              <DisabledPrompt>
                <UIButton className="primary-button" text="Update" />
              </DisabledPrompt>
            </FormButtonRow>
          </FormContainer>
        </CenterContentContainer>
      </PageContentView>
    </PageContainer>
  )
}
